import React from "react"
import withStyles from "react-jss"
import colors from "../data/colors"
import {
  HEADER_FADEIN,
  HEADER_FADEOUT,
  SECTION_DURATION,
} from "../data/globalStyles"

const URL =
  "https://assets.bonappetit.com/photos/616599c8813ead7dd5b5147c/master/pass/BA1121sides05%20.jpg"

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    height: "100vh",
    width: "100vw",
    background: `url(${URL}) no-repeat center center`,
    backgroundSize: "cover",
    animation: ({ show }) =>
      `${
        show ? `$${HEADER_FADEIN}` : `$${HEADER_FADEOUT}`
      } ${SECTION_DURATION} ease-in-out`,
  },
  intro: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: "1.3rem 4rem 1.3rem 4rem",
    border: "3px solid black",
    maxWidth: "1000px",
    background: colors.white,
    "@media only screen and (max-width: 720px)": {
      width: "100%",
      maxWidth: "100%",
      padding: "0 0 1.3rem 0",
    },
    "@media only screen and (max-width: 525px)": {
      width: "90%",
      padding: 0,
    },
  },
  heading: {
    fontSize: "calc(38px + (52 - 38) * ((100vw - 300px) / (1600 - 300)))",
    fontWeight: 600,
    margin: "0 0 0.8rem 0",
    textAlign: "center",
    lineHeight: "1.2em",
  },
  subheading: {
    fontWeight: 600,
    fontSize: "calc(14px + (20 - 14) * ((100vw - 300px) / (1600 - 300)))",
    padding: "0.5rem 2rem",
    margin: "1rem 0 0 0",
    lineHeight: "1.5em",
    textAlign: "center",
    background: colors.yellow,
  },
  start: {
    fontWeight: 600,
    fontSize: "calc(16px + (18 - 16) * ((100vw - 300px) / (1600 - 300)))",
    padding: "1rem 2rem",
    display: "flex",
    cursor: "pointer",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    textAlign: "center",
    boxSizing: "border-box",
    backgroundColor: colors.white,
    border: "none",
    color: colors.black,
  },
  transition: "background-color 0.2s ease-in-out",
  "&:hover": {
    color: colors.black,
  },
  "&:focus": {
    color: colors.yellow,
  },
  [`@keyframes ${HEADER_FADEIN}`]: {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  [`@keyframes ${HEADER_FADEOUT}`]: {
    from: {
      opacity: 1,
    },
    to: {
      opacity: 0,
    },
  },
}

const Header = ({ classes, setShow, section, onAnimationEnd }) => {
  return (
    section === "intro" && (
      <header className={classes.container} onAnimationEnd={onAnimationEnd}>
        <div className={classes.intro}>
          <h4 className={classes.subheading}>WHAT'S YOUR</h4>
          <h1 className={classes.heading}>
            Thanksgiving Side Dish Personality?
          </h1>
          <button
            className={classes.start}
            onClick={() =>
              setShow((d) => ({
                ...d,
                intro: false,
                quiz: true,
              }))
            }>
            <span>START</span>
          </button>
        </div>
      </header>
    )
  )
}

export default withStyles(styles)(Header)
